<template>
  <div class="container">
    <div class="BigImg"></div>
    <div class="centerall">
      <img
        src="@/assets/theSolution/educationBenefits2.webp"
        alt="背景图"
        class="background-img"
      />
    </div>
    <div class="centerall1">
      <img
        src="@/assets/theSolution/educationBenefits3.webp"
        alt="背景图"
        class="background-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.BigImg {
  width: 100%;
  height: 641px;
  background-size: cover; /* 背景图片铺满整个 div */
  background-image: url('@/assets/theSolution/educationBenefits1.webp');
  position: relative;
}

.centerall {
  position: relative;
  width: 100%;
  max-width: 880px;
  height: 718px;
  overflow: hidden;
}
.centerall1 {
  position: relative;
  width: 100%;
  max-width: 880px;
  height: 759px;
  margin-top: 50px;
  overflow: hidden;
}
/* 手机端适配 */
@media (max-width: 768px) {
  .BigImg {
    height: 156px;
    background-position: center;
  }

  .centerall,
  .centerall1 {
    width: 100%;
    max-width: 100%;
    height: 350px;
    margin: 0;

  }

}
</style>
